export default "__VITE_ASSET__ea1b5372__"